export default __webpack_public_path__ + "static/media/SecureUserExp.Header.38d14f86.png";